import { includes, reduce } from "lodash";
import { Country } from "@linkfluence/models/country";

export type Zone =
  | "EU"
  // | "ME"
  | "AS"
  | "OC"
  | "AF"
  | "OC"
  | "NA"
  // | "CA"
  // | "AT"
  | "SA"
  | "AUT";

const Zones: Record<Zone, Country[]> = {
  EU: [
    Country.AD, /// Andorra/
    Country.AL, /// Albania/
    Country.AT, ////
    Country.AM, /// Armenia/
    //* Country.AX, // Alland island *//
    Country.BA,
    Country.BE,
    Country.BG,
    Country.BY,
    Country.CH,
    Country.CY, /// Cyprus/
    Country.CZ,
    Country.DE,
    Country.DK,
    Country.EE,
    Country.ES,
    Country.FI,
    Country.FO,
    Country.FR,
    Country.GB,
    Country.GG,
    Country.GI,
    Country.GE, /// Georgia/
    Country.GR,
    Country.HR,
    Country.HU,
    Country.IE,
    Country.IM,
    Country.IS,
    Country.IT,
    Country.JE,
    Country.LI,
    Country.LT,
    Country.LU,
    Country.LV,
    Country.MC,
    Country.MD,
    Country.ME,
    Country.MK,
    Country.MT,
    Country.NL,
    Country.NO,
    Country.PL,
    Country.PT,
    Country.RO,
    Country.RS,
    Country.RU,
    Country.SE,
    Country.SI,
    Country.SJ,
    Country.SK,
    Country.SM,
    Country.TR,
    Country.UA,
    Country.VA,
  ],
  AS: [
    Country.AF, /// Afghanistan/
    Country.AZ,
    Country.BH, /// Bahrain/
    Country.BD,
    Country.BN,
    Country.BT,
    Country.CC,
    Country.CN,
    Country.HK,
    Country.ID,
    Country.IN,
    Country.IR, /// Iran/
    Country.IQ, /// Irak/
    Country.JO,
    Country.JP,
    Country.KG,
    Country.KH,
    Country.KP,
    Country.KR,
    Country.KZ,
    Country.LA,
    Country.LK,
    Country.OM, /// Oman/
    Country.MM,
    Country.MN,
    Country.MO,
    Country.MV,
    Country.MY,
    Country.NP,
    Country.PH,
    Country.PK,
    Country.SG,
    Country.TH,
    Country.TJ,
    Country.TL,
    Country.TM,
    Country.TW,
    Country.VN,
    Country.UZ, /// Uzbekiztan/
    Country.YE, /// Yemen/
    Country.QA, /// Qatar/
    Country.SA, /// Saudi Arabia/
    Country.LB, /// Lebanon/
    Country.KW, /// Kuwait/
    Country.JO, /// Jordan/
    Country.IL, /// Israel/
    Country.PS, /// Palestine/
    Country.SY, /// Syria/
    Country.AE, /// United Arabe Emirates/
  ],
  OC: [
    Country.AS,
    Country.AU,
    Country.CK,
    Country.FJ,
    Country.FM,
    Country.GU,
    Country.KI,
    Country.MH,
    Country.MP,
    Country.NC,
    Country.NU,
    Country.NZ,
    Country.PF,
    Country.PG,
    Country.PW,
    Country.SB,
    Country.TK,
    Country.TO,
    Country.TV,
    Country.VU,
    Country.WF,
    Country.WS,
  ],
  AF: [
    Country.AO,
    Country.BF,
    Country.BI,
    Country.BJ,
    Country.BW,
    Country.CD,
    Country.CF,
    Country.CG,
    Country.CI,
    Country.CM,
    Country.CV,
    Country.DJ,
    Country.DZ,
    Country.EH,
    Country.ER,
    Country.ET,
    Country.GA,
    Country.GH,
    Country.GM,
    Country.GN,
    Country.GQ,
    Country.GW,
    Country.KE,
    Country.KM,
    Country.LR,
    Country.LS,
    Country.LY,
    Country.MA,
    Country.MG,
    Country.ML,
    Country.MR,
    Country.MU,
    Country.MW,
    Country.MZ,
    Country.NA,
    Country.NE,
    Country.NG,
    Country.RE,
    Country.RW,
    Country.SC,
    Country.SD,
    Country.SH,
    Country.SL,
    Country.SN,
    Country.SO,
    Country.ST,
    Country.SZ,
    Country.TD,
    Country.TG,
    Country.TN,
    Country.TZ,
    Country.UG,
    Country.YT,
    Country.ZA,
    Country.ZM,
    Country.ZW,
    Country.EG, /// Egypte/
  ],
  NA: [
    Country.CA, /// Canada/
    Country.GL,
    Country.MX,
    Country.US,
    Country.AG,
    Country.AI,
    Country.AW,
    Country.BB,
    Country.BL,
    Country.BM,
    Country.BS,
    Country.CU,
    Country.DM,
    Country.DO,
    Country.GD,
    Country.GP,
    Country.HT,
    Country.JM,
    Country.KN,
    Country.KY,
    Country.LC,
    Country.MF,
    Country.MQ,
    Country.MS,
    // Country.POUR,
    Country.TC,
    // Country.TOUT,
    Country.VC,
    Country.VG,
    Country.VI,
    Country.BZ, /// Belize,/
    Country.SV, /// El Salvador/
    Country.HN, /// Honduras/
    Country.GT, /// Guatemala/
    Country.NI, /// Nicaragua/
    Country.PA, /// Panama/
    Country.CR, /// Costa Rica/
  ],
  SA: [
    Country.AR,
    Country.BO,
    Country.BR,
    Country.CL,
    Country.CO,
    Country.EC,
    Country.GF,
    Country.GY,
    Country.PE,
    Country.PY,
    Country.SR,
    Country.UY,
    Country.VE,
  ],
  AUT: [
    Country.SS,
    Country.XX,
    Country.AX,
    Country.BQ,
    Country.CW,
    Country.HM,
    Country.SX,
    Country.TT,
    Country.PR,
  ],
};

export function getAllZones() {
  return Zones;
}

export function getZoneFromCountry(country: Country) {
  return reduce(
    Zones,
    (acc, countries, zone) => {
      if (includes(countries, country)) {
        acc = zone;
      }
      return acc;
    },
    ""
  );
}
